import { h } from 'preact'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../../../modal'
import ButtonControl from '../../../button-control'

type Props = {
  numberOfSelectedTopics: number,
  categoryName?: string,
  isOpen: boolean,
  onMoveTo: () => void,
  onClose: () => void
}
const MoveToModal = ({ numberOfSelectedTopics, categoryName, isOpen, onMoveTo, onClose }: Props) =>
  <Modal isOpen={isOpen} size='medium'>
    <ModalHeader title='Move topics' onClose={() => onClose()} />
    <ModalBody>
      <div className='move-to-modal'>
        <p>Are you sure you want to move the selected <span class='bold'>{numberOfSelectedTopics} topics</span> to <span
          className='bold'>{categoryName}</span>?</p>
        <p>All subscribers of <span className='bold'>{categoryName}</span> will be notified about this change.</p>
      </div>
    </ModalBody>
    <ModalFooter>
      <ButtonControl
        title='Move topics'
        newStyle
        onClick={onMoveTo}
        size='medium'
        variant='brand'
      />
      <ButtonControl
        title='Cancel'
        newStyle
        onClick={onClose}
        size='medium'
      />
    </ModalFooter>
  </Modal>

export default MoveToModal
